import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css'; // Ensure global or page-specific stylesheet

const Home = () => {
    return (
        <div className="home-container">
            <h1 className="home-title">Welcome to 4rked</h1>
            <h2 className="home-subtitle">A Gift for Grandma & a Portal to Coding</h2>
            
            <div className="home-about">
                <p>
                    4rked is a fun, evolving recipe platform that I first created as a 
                    heartfelt gift for my grandma. She loves sharing family recipes, and 
                    I thought: what better way to keep them all in one place while <em>secretly</em> 
                    introducing her to modern coding methodologies? 
                </p>
                <p>
                    Through this site, we can explore new and classic recipes, share 
                    cooking tips, and even collaborate on improved or “forked” versions. 
                    Whether you’re a seasoned chef, a weekend dabbler, or a curious 
                    grandma learning about coding (shh, she doesn’t suspect a thing!), 
                    4rked is here to make delicious connections in and out of the kitchen.
                </p>
            </div>

            <div className="home-buttons">
                <Link to="/explore" className="home-link">
                    <button className="home-button explore-btn">Explore Recipes</button>
                </Link>
                <Link to="/login" className="home-link">
                    <button className="home-button login-btn">Login</button>
                </Link>
            </div>
        </div>
    );
};

export default Home;